import React from 'react';

const BlogPostsGridSection = ({ selectedCategory, blogPosts }) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts.filter(post => !post.featured)
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <section className="section-padding">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Tous les Articles</h2>
          <p className="section-subtitle">Explorez notre collection complète d'articles et guides</p>
        </div>
        <div className="row">
          {filteredPosts.map((post, index) => (
            <div className="col-lg-4 col-md-6 mb-5" key={post.id} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="card h-100 blog-card shadow-sm">
                <img 
                  src={post.image} 
                  className="card-img-top" 
                  alt={post.title}
                  style={{ height: '220px', objectFit: 'cover' }}
                />
                <div className="card-body d-flex flex-column">
                  <div className="mb-3">
                    <span className="badge bg-primary me-2">{post.category}</span>
                    <span className="text-muted small">{post.readTime}</span>
                  </div>
                  <h5 className="card-title mb-3">{post.title}</h5>
                  <p className="card-text flex-grow-1 mb-4">{post.excerpt}</p>
                  
                  {/* Additional content details */}
                  <div className="blog-details mb-3">
                    <div className="row text-muted small">
                      <div className="col-6">
                        <i className="fas fa-calendar-alt me-1"></i>
                        {formatDate(post.date)}
                      </div>
                      <div className="col-6 text-end">
                        <i className="fas fa-user me-1"></i>
                        {post.author}
                      </div>
                    </div>
                  </div>
                  
                  {/* Tags or additional info */}
                  <div className="blog-tags mb-3">
                    {post.tags && post.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="badge bg-light text-dark me-1 mb-1">#{tag}</span>
                    ))}
                  </div>
                  
                  {/* Engagement stats */}
                  <div className="blog-stats">
                    <div className="row text-muted small">
                      <div className="col-6">
                        <i className="fas fa-eye me-1"></i>
                        {post.views ? post.views.toLocaleString() : '0'} vues
                      </div>
                      <div className="col-6 text-end">
                        <i className="fas fa-share-alt me-1"></i>
                        {post.shares ? post.shares : '0'} partages
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPostsGridSection;
